export default function Input<T> (props: {value: T | undefined, type: "text" | "number", onChange: (value: T) => void, label: string}){
  return <div className={"text-input"}>
    {/*<label className={"text-input__label " + (props.value as string != "" ? "text-input__has_content" : "")}>{props.label}</label>*/}
    <input className={"text-input__input"} placeholder={props.label} type={props.type} value={props.value as string || ""} onChange={(value) => props.onChange(value.target.value as T) }/>
  </div>
}